import { BaseLoginError } from "./BaseLoginError";

export class UserInactive extends BaseLoginError {

    constructor(isShow : boolean) {
        super (isShow);
    }

}